import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import { PetitionGuidesPageContextProvider, prefetchPageContext } from 'src/app/pages/petitionGuides/pageContext';
import type { PetitionGuidesPagePrefetchedDataProps } from 'src/app/pages/petitionGuides/pageContext';

import { Layout } from '../layout';

import { PetitionGuidesErrorHandler } from './ErrorHandler';

export const PetitionGuidesLandingPage = withPrefetchedData(
	function PetitionGuides({ prefetchedData }: PetitionGuidesPagePrefetchedDataProps): JSX.Element {
		return (
			<PetitionGuidesPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={PetitionGuidesErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</PetitionGuidesPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,

		prefetchData: async (context) => prefetchPageContext(context),
	},
);
